/* eslint-disable max-len */
/* eslint-disable no-console */

import {Radio, Form, Input} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useState} from 'react';

import {SustanabilityQuestions} from '../Constants/SustanabilityQuestions';

interface SustainabilityDetailProps {
  index: number;
}

const {TextArea} = Input;

const SustainabilityDetailForm: React.FC<SustainabilityDetailProps> = ({
  index
}) => {
  const FormInstance = useFormInstance();
  const {setFields, getFieldValue} = FormInstance;

  const [value, setValue] = useState<string>();

  const onChange = (e: any) => {
    setValue(e.target.value);
  };

  const renderQuestion = () => {
    switch (index) {
      case 0:
        return (
          <>
            <p style={{fontSize: 16, fontWeight: 500}}>
              {SustanabilityQuestions.Group1.question}
            </p>
            <Form.Item
              name={['sustanability', SustanabilityQuestions.Group1.fieldName]}
            >
              <Radio.Group
                onChange={(e) => {
                  onChange(e);
                  setFields([
                    {
                      name: [
                        'sustanability',
                        SustanabilityQuestions.Group1.Comment.fieldName
                      ],
                      value: ''
                    }
                  ]);
                }}
                value={value}
                style={{display: 'flex', flexDirection: 'column', gap: '16px'}}
              >
                {SustanabilityQuestions.Group1.Options.map(
                  (item: any, index: number) => {
                    return (
                      <Radio key={`radio1${index}`} value={item.value}>
                        {item.label}
                      </Radio>
                    );
                  }
                )}
              </Radio.Group>
            </Form.Item>

            {(value === 'Other' ||
              getFieldValue([
                'sustanability',
                SustanabilityQuestions.Group1.fieldName
              ]) === 'Other') && (
              <Form.Item
                name={[
                  'sustanability',
                  SustanabilityQuestions.Group1.Comment.fieldName
                ]}
                label="Please specify reasons or details"
                rules={[
                  {required: true, message: 'Please provide some details'}
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="Explain why there's no awareness..."
                />
              </Form.Item>
            )}
          </>
        );

      case 1:
        return (
          <>
            <p style={{fontSize: 16, fontWeight: 500}}>
              {SustanabilityQuestions.Group2.question}
            </p>
            <Form.Item
              name={['sustanability', SustanabilityQuestions.Group2.fieldName]}
            >
              <Radio.Group
                onChange={onChange}
                value={value}
                style={{display: 'flex', flexDirection: 'column', gap: '16px'}}
              >
                {SustanabilityQuestions.Group2.Options.map(
                  (item: any, index: number) => {
                    return (
                      <Radio key={`radio1${index}`} value={item.value}>
                        {item.label}
                      </Radio>
                    );
                  }
                )}
              </Radio.Group>
            </Form.Item>
          </>
        );

      case 2:
        return (
          <>
            <p style={{fontSize: 16, fontWeight: 500}}>
              {SustanabilityQuestions.Group3.question}
            </p>
            <Form.Item
              name={['sustanability', SustanabilityQuestions.Group3.fieldName]}
            >
              <Radio.Group
                onChange={(e) => {
                  onChange(e);
                  setFields([
                    {
                      name: [
                        'sustanability',
                        SustanabilityQuestions.Group3.Comment.fieldName
                      ],
                      value: ''
                    }
                  ]);
                }}
                value={value}
                style={{display: 'flex', flexDirection: 'column', gap: '16px'}}
              >
                {SustanabilityQuestions.Group3.Options.map(
                  (item: any, index: number) => {
                    return (
                      <Radio key={`radio1${index}`} value={item.value}>
                        {item.label}
                      </Radio>
                    );
                  }
                )}
              </Radio.Group>
            </Form.Item>

            {(value === 'Other' ||
              getFieldValue([
                'sustanability',
                SustanabilityQuestions.Group3.fieldName
              ]) === 'Other') && (
              <Form.Item
                name={[
                  'sustanability',
                  SustanabilityQuestions.Group3.Comment.fieldName
                ]}
                label="Please specify reasons or details"
                rules={[
                  {required: true, message: 'Please provide some details'}
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="Explain why there's no awareness..."
                />
              </Form.Item>
            )}
          </>
        );

      case 3:
        return (
          <>
            <p style={{fontSize: 16, fontWeight: 500}}>
              {SustanabilityQuestions.Group4.question}
            </p>
            <Form.Item
              name={['sustanability', SustanabilityQuestions.Group4.fieldName]}
            >
              <Radio.Group
                onChange={onChange}
                value={value}
                style={{display: 'flex', flexDirection: 'column', gap: '16px'}}
              >
                {SustanabilityQuestions.Group4.Options.map(
                  (item: any, index: number) => {
                    return (
                      <Radio key={`radio1${index}`} value={item.value}>
                        {item.label}
                      </Radio>
                    );
                  }
                )}
              </Radio.Group>
            </Form.Item>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <div style={{marginTop: 20}}>{renderQuestion()}</div>
    </>
  );
};

export default SustainabilityDetailForm;
